import type { NClientServices } from '@app/types/ClientServices';
import type { NUtils } from '@app/types/Utils';

export const getUniqueCategories: NUtils.GetUniqueCategories = (
  data,
  categoryIdKey = 'CategoryId'
) => {
  const servicesWithUniqueCategories: NClientServices.ModelBranchClientService[] =
    [];

  data.forEach((service) => {
    const isUniqueCategory =
      servicesWithUniqueCategories.filter(
        ({ CategoryId: _CategoryId }) => _CategoryId === service[categoryIdKey]
      ).length === 0;

    if (isUniqueCategory) {
      return servicesWithUniqueCategories.push(service);
    }
  });

  return servicesWithUniqueCategories;
};
